// The caller's unread Inbox count, for the sidebar badge: one small read, refreshed each minute.
// Plain state, not react-query: the sidebar renders outside any QueryClientProvider (a query hook
// there took the whole app down, 2026-10-23). The Inbox page tells it about a read at once.
import { useEffect, useState } from 'react'
import { api } from '@/services/api'

const listeners = new Set<(n: number) => void>()
let last: number | null = null

/** The Inbox page reports a new unread count (a read, mark all read) so the badge moves at once. */
export function reportInboxUnread(n: number): void {
  last = n
  listeners.forEach((l) => l(n))
}

export function refreshInboxUnread(): void {
  api.listInbox({ unread_only: true, limit: 1 }).then((r) => reportInboxUnread(r.total ?? 0)).catch(() => {})
}

export function useInboxUnread(): number | null {
  const [count, setCount] = useState<number | null>(last)
  useEffect(() => {
    listeners.add(setCount)
    refreshInboxUnread()
    const t = setInterval(refreshInboxUnread, 60_000)
    return () => { listeners.delete(setCount); clearInterval(t) }
  }, [])
  return count
}
